/**
 * Service to fetch tenant ID from email address
 * This requires a backend API endpoint that uses Firebase Admin SDK
 */

import api from './api'

/**
 * Fetch tenant ID for a given email address
 * This calls a backend API that uses Firebase Admin SDK to look up the tenant
 */
export const fetchTenantIdByEmail = async (email) => {
  try {
    console.log('Fetching tenant ID for email:', email)
    
    const response = await api.post('/auth/lookup-tenant', { email })

    console.log('API Response status:', response.status)
    console.log('API Response data:', response.data)

    const data = response.data

    // Handle multiple tenants case
    if (data.multipleTenants && data.tenants && data.tenants.length > 0) {
      console.log('✅ Multiple tenants found:', data.tenants.length)
      return {
        tenantId: null, // No single tenant, user must choose
        exists: data.exists || true,
        tenants: data.tenants,
        multipleTenants: true,
      }
    }
    
    // Check if single tenantId is found
    if (data.tenantId !== undefined && data.tenantId !== null) {
      console.log('✅ Single Tenant ID found:', data.tenantId)
      return {
        tenantId: data.tenantId,
        exists: data.exists || true,
        displayName: data.displayName,
      }
    }
    
    // If tenantId is null or undefined, user might not be in a tenant
    console.log('⚠️ No tenant ID returned from API')
    return {
      tenantId: null,
      exists: data.exists || false,
    }
  } catch (error) {
    console.error('Error fetching tenant ID:', error)
    
    // Handle permission errors specifically
    if (error.response?.status === 403 || error.response?.data?.error === 'Permission denied') {
      return {
        tenantId: null,
        exists: false,
        error: 'Service account permissions issue. Please check backend setup. You can enter tenant ID manually.',
      }
    }
    
    return {
      tenantId: null,
      exists: false,
      error: error.response?.data?.message || error.message || 'Failed to fetch tenant ID. Please enter it manually.',
    }
  }
}

